import {SystemEventSource} from 'src/openapi/models/SystemEventSource';
import {UserEventSource} from 'src/openapi/models/UserEventSource';

export const getAllSources = (): string[] => {
    return Array.from(
        new Set([
            ...Object.values(UserEventSource),
            ...Object.values(SystemEventSource),
        ]),
    );
};
